"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentDataProvider = void 0;
const domain_1 = require("../../../domain");
const lodash_1 = require("lodash");
const rxjs_1 = require("rxjs");
class AssignmentDataProvider {
    constructor(assignmentProvider, metaProvider, entryProvider) {
        this.assignmentProvider = assignmentProvider;
        this.metaProvider = metaProvider;
        this.entryProvider = entryProvider;
    }
    async data(id) {
        const [assignment, meta] = await Promise.all([this.assignmentProvider.assignment(id), this.metaProvider.meta(id)]);
        return assignment && meta && { assignment, meta };
    }
    async dataFromAssignments(assignments) {
        const results = await Promise.all(assignments.map(async (assignment) => {
            const meta = await this.metaProvider.meta(assignment._id);
            return meta && { meta, assignment };
        }));
        return (0, lodash_1.compact)(results);
    }
    async dataFromMetas(metas) {
        const results = await Promise.all(metas.map(async (meta) => {
            const assignment = await this.assignmentProvider.assignment(meta._id);
            return assignment && { meta, assignment };
        }));
        return (0, lodash_1.compact)(results);
    }
    dataStream(id) {
        return (0, rxjs_1.combineLatest)(this.assignmentProvider.assignmentStream(id), this.metaProvider.metaStream(id), (assignment, meta) => assignment && meta && { assignment, meta });
    }
    dataWithEntriesStream(assignmentId) {
        return (0, rxjs_1.combineLatest)(this.dataStream(assignmentId), this.entryProvider.entriesForAssignmentStream(assignmentId), (assignment, entries) => domain_1.AssignmentDataWithEntries.from(assignment, entries));
    }
}
exports.AssignmentDataProvider = AssignmentDataProvider;
//# sourceMappingURL=AssignmentDataProvider.js.map